export function typographyConfig({ colors }) {
    const common = {
        borderTop: `2px solid ${colors.divider.color}`,
        color: colors.text.headlineColor
    };
    return {
        headline1: common,
        headline2: common,
        headline3: common,
        headline4: {
            ...common,
            fontSize: "13px",
            textTransform: "none"
        },
        headline5: {
            ...common,
            fontSize: "12px"
        }
    };
}
